import { isEmpty } from 'lodash';
import type { LayerPattern } from '../patterns/index';
import { LAYER_SETTINGS_TYPES } from '../constants';
import { VoronoiSvg } from './icons';
import { state } from '@/components/MapGeneration/store/state';

export const voronoi: LayerPattern = {
    id: 'voronoi',
    key: 'voronoi',
    title: 'Диаграмма Вороного',
    icon: VoronoiSvg,
    // settings: [],
    settingsInit: (activeFieldId: number | undefined) => [
        {
            title: 'Месторождение',
            key: 'activeFieldId',
            type: LAYER_SETTINGS_TYPES.SELECT,
            defaultValue: !isEmpty(state.fields) ? state.fields[0].id : 0,
            options: state.fields.map(field => ({
                value: String(field.id),
                label: String(field.label),
            })),
            level: 0,
        },
        {
            title: 'Пласт',
            key: 'activeStratumId',
            type: LAYER_SETTINGS_TYPES.SELECT,
            // defaultValue: state.uniqueStrataList.filter(item => item.field_id === state.fields[0].id)[0]?.stratum_id,
            defaultValue:
                state.uniqueStrataList.find(item => item.field_id === activeFieldId)?.stratum_id ??
                state.uniqueStrataList.filter(item => item.field_id === state.fields[0].id)[0]?.stratum_id,
            // options: state.uniqueStrataList
            //     .filter(item => state.fields.some(field => field.id === item.field_id))
            //     .map(item => {
            //         return {
            //             value: String(item.stratum_id),
            //             label: String(item.stratum_name),
            //         };
            //     }),
            options: state.uniqueStrataList
                .filter(item => item.field_id === activeFieldId)
                .map(item => ({
                    value: String(item.stratum_id),
                    label: String(item.stratum_name),
                })),
            level: 0,
        },
    ],
};
